var layout2 = "col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6";
var layout3 = "col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4";
var layout4 = "col-6 col-sm-6 col-md-4 col-lg-3 col-xl-3";
var layout5 = "col-6 col-sm-6 col-md-3 col-lg-3 col-xl-2";
var hideShowFiltersEvent = false;
var clearAllFilterButton = false;
let clearAllButton = document.getElementById('yv-applied-filter-cross-all');
var filters = document.getElementById('filterSideBar');
var filterContainer = document.getElementById('CollectionProductsContainer');
if(clearAllButton){
  clearAllFilterButton = true;
}
function changeGridLayout() {
    let parent = document.getElementById('CollectionProductsContainer');
    let gridLayouts = document.querySelectorAll('.sort-grid-icon');
    Array.from(gridLayouts).forEach(function(layoutItem) {
        layoutItem.classList.remove('active');
    });

    var grid_layout_collection = Cookies.get('grid_layout_collection');
    if (parent && gridLayouts.length > 0) {
        if (window.innerWidth < 768) {
            if (grid_layout_collection && grid_layout_collection != "grid-layout-4" && grid_layout_collection != "grid-layout-5") {
                document.querySelector('.sort-grid-icon[data-value="' + grid_layout_collection + '"]').classList.add('active');
                parent.setAttribute("data-view", grid_layout_collection)
            } else {
                document.querySelector('.sort-grid-icon[data-value="grid-layout-2"]').classList.add('active');
                parent.setAttribute("data-view", "grid-layout-2")
            }
        } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
            if (grid_layout_collection && grid_layout_collection != "grid-layout-4" && grid_layout_collection != "grid-layout-5") {
                document.querySelector('.sort-grid-icon[data-value="' + grid_layout_collection + '"]').classList.add('active');
                parent.setAttribute("data-view", grid_layout_collection)
            } else {
                document.querySelector('.sort-grid-icon[data-value="grid-layout-3"]').classList.add('active');
                parent.setAttribute("data-view", "grid-layout-3")
            }
        } else if (window.innerWidth >= 992) {
            if (grid_layout_collection) {
                document.querySelector('.sort-grid-icon[data-value="' + grid_layout_collection + '"]').classList.add('active');
                parent.setAttribute("data-view", grid_layout_collection)
            } else {
                document.querySelector('.sort-grid-icon[data-value="grid-layout-4"]').classList.add('active');
                parent.setAttribute("data-view", "grid-layout-4")
            }
        }
        updateGridView(parent);

    }
}

function hideShowFilters() {
    var filterHeading = document.getElementById('filterHeading');
    if (window.innerWidth < 768) {
        if (filterContainer && filterHeading) {
            if (filterHeading.classList.contains('filters-drawer-toggle')) {
                filterContainer.classList.add('filters-toggle');
            }
        }
    } else {
        if (filters) {
            filters.classList.remove('active')
            document.querySelector('body').classList.remove('open-filter-sort');
        }
    }
    if (hideShowFiltersEvent == false ) {
        if (filterHeading) {
            filterHeading.addEventListener("click", (e) => {
              e.preventDefault();
                if (window.innerWidth > 767) {
                    if (filterContainer && filterHeading) {
                        if (filterHeading.classList.contains('filters-drawer-toggle')) {
                            DOMAnimations.classToggle(filterContainer, 'filters-toggle');
                        }
                    }
                } else {
                    filters.classList.add('active')
                    document.querySelector('body').classList.add('open-filter-sort');
                }
            });
        }
        hideShowFiltersEvent = true;
    }
}
function hideFilters(){
  var cancelFiltes = document.getElementById('cancelFilters');
  if (cancelFiltes) {
    cancelFiltes.addEventListener("click", (e) => {
      e.preventDefault();
      filters.classList.remove('active')
      document.querySelector('body').classList.remove('open-filter-sort');
    });
  }
}
window.addEventListener('load', (event) => {
    changeGridLayout();
    hideShowFilters();
    applyFilters();
    sortByOptions();
    showMoreFilters();
    hideFilters();
  sortBy();
});
window.addEventListener('resize', function(event) {
    changeGridLayout();
    applyFilters();
    hideShowFilters();
    sortByVisibilityChange(); 
    var filters = document.getElementById('filterSideBar');
    if (filters) {
        if (window.innerWidth < 768 && window.innerWidth > 760) {
            filters.style.display = 'none';
            setTimeout(function() { filters.style.display = ''; }, 500)
        }
    }

});

function showMoreFilters() {
    const filterForm = document.getElementById('FiltersForm');
    if(filterForm){
        var showMoreFilters = filterForm.querySelectorAll('.filters-expand');
        if (showMoreFilters) {
            Array.from(showMoreFilters).forEach(function(showMoreFilter) {
                showMoreFilter.addEventListener("click", (e) => {
                    e.preventDefault();
                    if (showMoreFilter.classList.contains('active')) {
                        showMoreFilter.classList.remove('active');
                        DOMAnimations.slideUp(showMoreFilter.parentNode.querySelector('.more-options'), 150);
                        showMoreFilter.querySelector('span').textContent = showMoreText;
                    } else {
                        showMoreFilter.classList.add('active');
                        DOMAnimations.slideDown(showMoreFilter.parentNode.querySelector('.more-options'), 150);
                        showMoreFilter.querySelector('span').textContent = showLessText;
                    }
                });
            });
        }
    }
}

function applyFilters() {
    var section = document.getElementById('CollectionProductsContainer');
    if (section) {
        var sectionParent = section.closest('.shopify-section');
        var sectionId = section.dataset.id;
        const filterForm = document.getElementById('FiltersForm');
        if (!filterForm) {
            return false;
        }
        //   showMultipleOptions(); 
        var layouts = sectionParent.querySelectorAll('.sort-grid-icon');
        Array.from(layouts).forEach(function(layout) {
            layout.addEventListener("click", (e) => {
                e.preventDefault();
                if (!layout.classList.contains('active')) {
                    layout.classList.add('active');
                    let allGrids = section.querySelectorAll('.aos-init');

                    Array.from(allGrids).forEach(function(grid) {
                        grid.classList.remove('aos-animate');
                        grid.classList.remove('aos-init');
                    });

                    setTimeout(function() {
                        Array.from(layouts).forEach(function(layoutItem) {
                            if (layoutItem != layout) {
                                layoutItem.classList.remove('active');
                            }
                        });
                        var _thisLayout = layout.dataset.value;
                        section.setAttribute('data-view', _thisLayout)
                        updateGridView(section);
                        var date = new Date();

                        date.setTime(date.getTime() + (parseInt(24 * 60 * 60 * 1000)));
                        Cookies.set('grid_layout_collection', _thisLayout, { expires: date, path: '/' });
                        let allImages = section.querySelectorAll('.lazyloaded');

                        Array.from(allImages).forEach(function(image) {
                            image.classList.remove('lazyloaded');
                            image.classList.add('lazyload');
                        });
                    }, 800);
                }

            });
        });

        var priceRangeBars = filterForm.querySelectorAll('.mall-slider-handles');
        Array.from(priceRangeBars).forEach(function(rangeBar) {
            var el = rangeBar;
            var sliderEventListener = '';
            if (el.noUiSlider) {
                sliderEventListener = el.noUiSlider;
            } else {
                sliderEventListener = noUiSlider.create(el, {
                    start: [el.dataset.start, el.dataset.end],
                    step: 1,
                    connect: true,
                    tooltips: false,
                    range: {
                        min: [parseInt(el.dataset.min)],
                        max: [parseInt(el.dataset.max)]
                    }
                });
            }
            if (window.innerWidth > 767) {
                sliderEventListener.on('change', function(values) {
                    var minRange = $(this)[0].options.range.min;
                    var maxRange = $(this)[0].options.range.max;
                    var minVal = parseInt(values[0]);
                    var newformatMoney = moneyFormat;
                    if (minVal > minRange) {
                        section.querySelectorAll('input[name="filter.v.price.gte"]')[0].value = minVal;
                    }
                    var maxVal = parseInt(values[1]);
                    if (maxVal < maxRange) {
                        section.querySelectorAll('input[name="filter.v.price.lte"]')[0].value = maxVal;
                    }
                  if (window.innerWidth > 767) {
                    getFilterData(rangeBar, sectionId);
                  }
                })
            }
            sliderEventListener.on("update", function(values) {
                var minRange = $(this)[0].options.range.min;
                var maxRange = $(this)[0].options.range.max;
                var minVal = parseInt(values[0]);
                // var newformatMoney = moneyFormat;
                // section.querySelector('[data-min-value]').innerHTML =  Shopify.formatMoney(minVal*100,moneyFormatWithoutCurrency);
                // var maxVal =  parseInt(values[1]);
                // section.querySelector('[data-max-value]').innerHTML = Shopify.formatMoney(maxVal*100,moneyFormatWithoutCurrency);
                if (minVal > minRange) {
                    section.querySelectorAll('input[name="filter.v.price.gte"]')[0].value = minVal;
                }
                var maxVal = parseInt(values[1]);
                if (maxVal < maxRange) {
                    section.querySelectorAll('input[name="filter.v.price.lte"]')[0].value = maxVal;
                }
            })
        })

        if (window.innerWidth > 767) {
            var prices = filterForm.querySelectorAll('input[type=number]');
            Array.from(prices).forEach(function(price) {
                price.addEventListener("change", () => {
                    getFilterData(price, sectionId)
                });
            });
            var inputs = filterForm.querySelectorAll('input[type=checkbox]');
            Array.from(inputs).forEach(function(input) {
                input.addEventListener("click", () => {
                  if (window.innerWidth > 767) {
                    getFilterData(input, sectionId)
                  }
                });
            });
        } else {
            filterForm.addEventListener("submit", (e) => {
                e.preventDefault();
                getFilterData(filterForm, sectionId)
                document.querySelector('body').classList.remove('open-filter-sort');
            });
        }

      var removeFilters = sectionParent.querySelectorAll('a.yv-applied-filter-remove');
        Array.from(removeFilters).forEach(function(removeFilter) {
            if(removeFilter.id == 'yv-applied-filter-cross-all' & clearAllFilterButton == false){
              return false;
            }
          else{
              clearAllFilterButton == false
              removeFilter.addEventListener("click", (e) => {
                  e.preventDefault();
                  var _url = removeFilter.getAttribute('href');
                  getFilterData(removeFilter, sectionId, _url);
              });
            }
        });
    }
}

function sortByOptions() {
    var section = document.getElementById('CollectionProductsContainer');
    var sortBy = document.querySelectorAll('[name="sort_by"]');
    if(section){
        var sectionId = section.dataset.id;
        Array.from(sortBy).forEach(function(sort) {
            sort.addEventListener("change", (e) => {
                e.preventDefault();
                Array.from(sortBy).forEach(function(sort) {
                    sort.parentNode.classList.remove('selected');
                })

                sort.parentNode.classList.add('selected');
                var sortMenu = document.getElementById('sort__list');
                if (sortMenu.classList.contains('active')) {
                    sortMenu.classList.remove('active');
                    if (window.innerWidth > 767) {
                        DOMAnimations.slideUp(sortMenu);
                    } else {
                        document.querySelector('body').classList.remove('open-filter-sort');
                    }
                }
                document.querySelector('body').classList.remove('open-filter-sort');
                getFilterData(sort, sectionId);
            });
        });
    }
}
function sortByVisibilityChange(){
     var sortMenu = document.querySelector('.collection-sortby-selected');
    var sortList = document.getElementById('sort__list');
    if (sortMenu && sortList) {
        if (window.innerWidth > 767) {
          if(sortList.classList.contains('active')){
            sortList.style.display = 'block';
          }else{
            sortList.style.display = 'none';
          }
          document.querySelector('body').classList.remove('open-filter-sort');
          
        }else{
          sortList.style.display = 'block';
          if(sortList.classList.contains('active')){
          document.querySelector('body').classList.add('open-filter-sort');
          }else{
          document.querySelector('body').classList.remove('open-filter-sort');
          }
        }
    }
}
function sortBy() {
    var sortMenu = document.querySelector('.collection-sortby-selected');
    if (sortMenu) {          
        sortMenu.addEventListener("click", (e) => {
            e.preventDefault();
            var sortMenu = document.getElementById('sort__list');
            if (sortMenu.classList.contains('active')) {
                sortMenu.classList.remove('active');
                if (window.innerWidth > 767) {
                    DOMAnimations.slideUp(sortMenu);
                } else {
                    document.querySelector('body').classList.remove('open-filter-sort');
                }
            } else {
                sortMenu.classList.add('active');
                if (window.innerWidth > 767) {
                    DOMAnimations.slideDown(sortMenu);
                } else {
                    document.querySelector('body').classList.add('open-filter-sort');
                }
            }
        });
    }
    var closeSortMenu = document.querySelector('.close-sort');
    if (closeSortMenu) {
        closeSortMenu.addEventListener("click", (e) => {
            e.preventDefault();
            var sortMenu = document.getElementById('sort__list');
            if (window.innerWidth < 768) {
                sortMenu.classList.remove('active');
                document.querySelector('body').classList.remove('open-filter-sort');
            }
        });
    }
}

function getColumnCountFromLayout(layout) {
    switch(layout) {
        case 'grid-layout-2': return 2;
        case 'grid-layout-3': return 3;
        case 'grid-layout-4': return 4;
        case 'grid-layout-5': return 5;
        default: return 4;
    }
}

function shouldBeUnsplashSlot(itemIndex, columns) {
    // Skip first row completely
    if (itemIndex < columns) {
        return false;
    }
    
    // Calculate which row this item is in (0-based, but first row is skipped)
    var rowIndex = Math.floor(itemIndex / columns);
    
    // Check if we're on mobile
    var isMobile = window.innerWidth < 768;
    
    // Different patterns for mobile vs desktop
    if (isMobile) {
        // Mobile: Skip 2 rows between images (every 3rd row after first)
        // Rows with images: 3, 6, 9, 12, etc. (0-based: 2, 5, 8, 11, etc.)
        if ((rowIndex - 2) % 3 !== 0 || rowIndex < 2) {
            return false;
        }
    } else {
        // Desktop: Skip 1 row between images (every 2nd row after first)  
        // Rows with images: 2, 4, 6, 8, etc. (0-based: 1, 3, 5, 7, etc.)
        if (rowIndex % 2 === 0) {
            return false;
        }
    }
    
    // Position within the row (0 to columns-1)
    var positionInRow = itemIndex % columns;
    
    // Determine which unsplash row this is (counting only the rows where we place unsplash)
    var unsplashRowCount;
    if (isMobile) {
        unsplashRowCount = Math.floor((rowIndex - 2) / 3);
    } else {
        unsplashRowCount = Math.floor((rowIndex - 1) / 2);
    }
    
    // Alternate between last position and first position
    if (unsplashRowCount % 2 === 0) {
        // Even unsplash row: place at last position
        return positionInRow === (columns - 1);
    } else {
        // Odd unsplash row: place at first position  
        return positionInRow === 0;
    }
}

function getGalleryMetafieldData() {
    var metafieldScript = document.getElementById('gallery-metafield-data');
    if (metafieldScript) {
        try {
            console.log('🖼️ Raw JSON from Liquid template:');
            console.log(metafieldScript.textContent);
            
            var data = JSON.parse(metafieldScript.textContent);
            console.log('🖼️ Gallery Images Debug:');
            console.log('- Images array:', data.images);
            console.log('- Images count:', data.images ? data.images.length : 'undefined');
            console.log('- First image:', data.images ? data.images[0] : 'no images');
            console.log('- Are images valid URLs?', data.images && data.images[0] && (data.images[0].startsWith('http') || data.images[0].startsWith('//') || data.images[0].startsWith('data:')));
            
            // Check if we have actual image URLs (not empty or placeholder)
            if (data.images && data.images.length > 0 && data.images[0] && data.images[0] !== '' && !data.images[0].includes('Gallery Image')) {
                console.log('✅ Using metafield gallery images');
                return data;
            } else {
                console.log('⚠️ Metafield images are empty or placeholders, using fallback');
            }
        } catch (e) {
            console.warn('Error parsing gallery metafield data:', e);
        }
    } else {
        console.error('gallery-metafield-data script tag not found');
    }
    
    // Fallback to placeholder SVGs only - no product images
    return {
        images: [
            'data:image/svg+xml;base64,' + btoa('<svg xmlns="http://www.w3.org/2000/svg" width="600" height="600" viewBox="0 0 600 600"><rect width="600" height="600" fill="#f8f8f8"/><text x="300" y="280" font-family="Arial" font-size="18" fill="#999" text-anchor="middle">Gallery</text><text x="300" y="310" font-family="Arial" font-size="18" fill="#999" text-anchor="middle">Image 1</text></svg>'),
            'data:image/svg+xml;base64,' + btoa('<svg xmlns="http://www.w3.org/2000/svg" width="600" height="600" viewBox="0 0 600 600"><rect width="600" height="600" fill="#f0f0f0"/><text x="300" y="280" font-family="Arial" font-size="18" fill="#999" text-anchor="middle">Gallery</text><text x="300" y="310" font-family="Arial" font-size="18" fill="#999" text-anchor="middle">Image 2</text></svg>'),
            'data:image/svg+xml;base64,' + btoa('<svg xmlns="http://www.w3.org/2000/svg" width="600" height="600" viewBox="0 0 600 600"><rect width="600" height="600" fill="#e8e8e8"/><text x="300" y="280" font-family="Arial" font-size="18" fill="#999" text-anchor="middle">Gallery</text><text x="300" y="310" font-family="Arial" font-size="18" fill="#999" text-anchor="middle">Image 3</text></svg>'),
            'data:image/svg+xml;base64,' + btoa('<svg xmlns="http://www.w3.org/2000/svg" width="600" height="600" viewBox="0 0 600 600"><rect width="600" height="600" fill="#e0e0e0"/><text x="300" y="280" font-family="Arial" font-size="18" fill="#999" text-anchor="middle">Gallery</text><text x="300" y="310" font-family="Arial" font-size="18" fill="#999" text-anchor="middle">Image 4</text></svg>'),
            'data:image/svg+xml;base64,' + btoa('<svg xmlns="http://www.w3.org/2000/svg" width="600" height="600" viewBox="0 0 600 600"><rect width="600" height="600" fill="#d8d8d8"/><text x="300" y="280" font-family="Arial" font-size="18" fill="#999" text-anchor="middle">Gallery</text><text x="300" y="310" font-family="Arial" font-size="18" fill="#999" text-anchor="middle">Image 5</text></svg>')
        ],
        titles: [
            'Gallery Inspiration',
            'Studio Essentials',
            'Creative Workspace',
            'Artistic Vision',
            'Frame Perfect'
        ],
        subtitles: [
            'Discover the perfect frame for your masterpiece',
            'Essential tools for every artist studio',
            'Where creativity comes to life',
            'Bringing your artistic vision to reality',
            'The art of perfect presentation'
        ],
        cta_texts: [
            'Browse Frames',
            'Shop Supplies',
            'View Gallery',
            'Get Inspired',
            'Shop Now'
        ],
        cta_links: [
            '/collections/art-frames',
            '/collections/art-supplies',
            '/collections/gallery-picks',
            '/collections/trending-frames',
            '/collections/all'
        ]
    };
}

function updateUnsplashImages(section) {
    // Only run rotating images for collage_it template
    var mainSection = document.getElementById('CollectionProductsContainer');
    var isCollageItTemplate = mainSection && mainSection.getAttribute('data-collage-it') === 'true';
    
    if (!isCollageItTemplate) {
        return; // Exit early if not collage_it template
    }
    
    var _layout = mainSection.getAttribute('data-view');
    var columns = getColumnCountFromLayout(_layout);
    
    var productGrid = section.querySelector('[data-collection-products]');
    if (!productGrid) return;
    
    var allItems = productGrid.querySelectorAll('[data-product-grid]');
    
    // Get metafield data
    var galleryData = getGalleryMetafieldData();
    
    var imageUrls = galleryData.images;
    var overlayTitles = galleryData.titles;
    var overlaySubtitles = galleryData.subtitles;
    var cardTitles = galleryData.titles; // Using same titles for cards
    var ctaTexts = galleryData.cta_texts;
    var ctaLinks = galleryData.cta_links;
    
    console.log('🎯 Will use these images for gallery slots:', imageUrls);
    
    // Get all original product items (only products, not existing unsplash)
    var productItems = [];
    Array.from(allItems).forEach(function(item) {
        if (!item.querySelector('.unsplash-item')) {
            productItems.push(item.innerHTML);
        }
    });
    
    // Calculate positions where we need Unsplash images
    var unsplashPositions = [];
    var totalNeededSlots = productItems.length;
    var currentIndex = 0;
    
    // Keep adding positions until we account for all products
    while (currentIndex < totalNeededSlots + unsplashPositions.length) {
        if (shouldBeUnsplashSlot(currentIndex, columns)) {
            unsplashPositions.push(currentIndex);
        }
        currentIndex++;
    }
    
    // Create new layout with products shifted to accommodate Unsplash images
    var finalLayout = [];
    var productIndex = 0;
    var unsplashIndex = 0;
    
    for (var i = 0; i < totalNeededSlots + unsplashPositions.length; i++) {
        if (unsplashPositions.includes(i)) {
            // This position gets an Unsplash image
            var collectionTitle = document.querySelector('.collection-banner-title')?.textContent || 'lifestyle';
            var startImageIndex = unsplashIndex % imageUrls.length;
            
            var cleanImageUrl = imageUrls[startImageIndex];
            // Fix duplicate /files/ in URLs
            if (cleanImageUrl && cleanImageUrl.includes('/files/files/')) {
                cleanImageUrl = cleanImageUrl.replace('/files/files/', '/files/');
            }
            
            var unsplashHTML = 
                '<div class="yv-product-card" style="opacity: 0; transition: opacity 0.3s ease;">' +
                    '<div class="yv-product-img unsplash-item" data-image-index="' + i + '" style="aspect-ratio: 1/1; height: auto; position: relative; cursor: pointer;" onmouseover="this.querySelector(\'.unsplash-overlay\').style.opacity=\'1\'; window.pauseCarousel && window.pauseCarousel(\'' + i + '\');" onmouseout="this.querySelector(\'.unsplash-overlay\').style.opacity=\'0\'; window.resumeCarousel && window.resumeCarousel(\'' + i + '\');">' +
                        '<img id="unsplash-img-' + i + '" src="' + cleanImageUrl + '" ' +
                             'alt="Inspirational image related to ' + collectionTitle + '" ' +
                             'loading="lazy" style="width: 100%; height: 100%; object-fit: cover;" ' +
                             'onload="this.closest(\'.yv-product-card\').style.opacity = \'1\';">' +
                        '<div class="unsplash-overlay" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.4); display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; padding: 1rem; opacity: 0; transition: opacity 0.3s ease; pointer-events: none;">' +
                            '<h3 id="overlay-title-' + i + '" style="color: white; font-size: 1.2rem; font-weight: 600; margin: 0 0 0.5rem 0; line-height: 1.2;">' +
                                overlayTitles[startImageIndex] +
                            '</h3>' +
                            '<p id="overlay-subtitle-' + i + '" style="color: white; font-size: 0.9rem; font-weight: 400; margin: 0 0 1rem 0; line-height: 1.3; opacity: 0.9;">' +
                                overlaySubtitles[startImageIndex] +
                            '</p>' +
                            '<a href="' + ctaLinks[startImageIndex] + '" id="overlay-cta-' + i + '" style="margin-top: 1rem; background: transparent; color: #fff; border: 1px solid #fff; padding: 0.5rem 1rem; border-radius: 4px; text-decoration: none; font-weight: 500; font-size: 0.85rem; transition: all 0.3s ease; display: inline-block; pointer-events: auto; transform: translateY(0); box-shadow: 0 2px 4px rgba(0,0,0,0.1);" onmouseover="this.style.transform=\'translateY(-2px)\'; this.style.boxShadow=\'0 4px 12px rgba(0,0,0,0.15)\'; this.style.background=\'#fff\'; this.style.color=\'#000\';" onmouseout="this.style.transform=\'translateY(0)\'; this.style.boxShadow=\'0 2px 4px rgba(0,0,0,0.1)\'; this.style.background=\'transparent\'; this.style.color=\'#fff\';">' +
                                ctaTexts[startImageIndex] +
                            '</a>' +
                        '</div>' +
                        '<script type="application/json" id="image-data-' + i + '">' + JSON.stringify(imageUrls) + '</script>' +
                        '<script type="application/json" id="overlay-titles-' + i + '">' + JSON.stringify(overlayTitles) + '</script>' +
                        '<script type="application/json" id="overlay-subtitles-' + i + '">' + JSON.stringify(overlaySubtitles) + '</script>' +
                        '<script type="application/json" id="card-titles-' + i + '">' + JSON.stringify(cardTitles) + '</script>' +
                        '<script type="application/json" id="cta-texts-' + i + '">' + JSON.stringify(ctaTexts) + '</script>' +
                        '<script type="application/json" id="cta-links-' + i + '">' + JSON.stringify(ctaLinks) + '</script>' +
                    '</div>' +
                    '<div class="yv-product-information">' +
                        '<a href="#" class="yv-product-title" id="unsplash-title-' + i + '" style="min-height: 45px; display: block;">' +
                            cardTitles[startImageIndex] +
                        '</a>' +
                    '</div>' +
                '</div>';
            
            finalLayout.push({type: 'unsplash', content: unsplashHTML});
            unsplashIndex++;
        } else {
            // This position gets a product
            if (productIndex < productItems.length) {
                finalLayout.push({type: 'product', content: productItems[productIndex]});
                productIndex++;
            }
        }
    }
    
    // Update the actual DOM elements
    Array.from(allItems).forEach(function(item, index) {
        if (index < finalLayout.length) {
            item.innerHTML = finalLayout[index].content;
        } else {
            // Remove extra items if we have fewer total items now
            item.remove();
        }
    });
    
    // Add new items if we need more
    for (var i = allItems.length; i < finalLayout.length; i++) {
        var newItem = document.createElement('div');
        newItem.setAttribute('data-product-grid', '');
        newItem.innerHTML = finalLayout[i].content;
        productGrid.appendChild(newItem);
    }
}

function updateGridView(section) {
    if (section) {
        var mainSection = document.getElementById('CollectionProductsContainer');
        var _layout = mainSection.getAttribute('data-view');
        var productItems = section.querySelectorAll('[data-product-grid]');
        if (productItems.length > 0) {
            Array.from(productItems).forEach(function(item) {
                if (_layout == 'grid-layout-2') {
                    item.setAttribute('class', layout2);
                } else if (_layout == 'grid-layout-3') {
                    item.setAttribute('class', layout3);
                } else if (_layout == 'grid-layout-4') {
                    item.setAttribute('class', layout4);
                } else if (_layout == 'grid-layout-5') {
                    item.setAttribute('class', layout5);
                }
            });
        }
        
        updateUnsplashImages(section);
        
        // Start carousels for new Unsplash items
        setTimeout(function() {
            startUnsplashCarousels();
        }, 500);
        
        if(animationStatus){
          if (AOS) { 
            AOS.refreshHard() 
          }
        }
    }
}

function fetchFilterData(url) {
    return fetch(url)
        .then(response => response.text())
}

function getFilterData(input, sectionId, remove) {
    //   document.getElementById('CollectionProductsContainer').querySelector('.filteredData').classList.add('filtering')

    let allGrids = document.getElementById('CollectionProductsContainer').querySelectorAll('.aos-init');

    Array.from(allGrids).forEach(function(grid) { 
        grid.classList.remove('aos-animate');
        grid.classList.remove('aos-init');
    });
    let filterForm = document.getElementById('FiltersForm');
    const formData = new FormData(filterForm);
    var searchParameters = new URLSearchParams(formData).toString();
    var clearAll = document.getElementById('yv-applied-filter-cross-all');
    
    var url = window.location.pathname + '?section_id=' + sectionId + '&' + searchParameters;
    var _updateUrl = window.location.pathname + '?' + searchParameters;
    if (remove) {
        url = remove;
        _updateUrl = remove;
    }
    const html = fetchFilterData(url).
    then((responseText) => {
        const resultData = new DOMParser().parseFromString(responseText, 'text/html');
        var itemResultCount = resultData.querySelector('.products-count');
        var sortByHtml = '';
        if (resultData.getElementById('toolbox-sort')) {
            sortByHtml = resultData.getElementById('toolbox-sort').innerHTML;
        }

        var html = resultData.getElementById('CollectionProductsContainer');
        var resultClear = resultData.getElementById('yv-applied-filter-cross-all')
        if (resultClear) {
            if (!document.getElementById('yv-applied-filter-cross-all')) {
                document.querySelector('.filter-heading-wrapper').appendChild(resultClear);
                clearAllFilterButton = true;
            }
          else{
            clearAllFilterButton = false;
          }
        }else{
            if (clearAll) {
                clearAll.remove();
                clearAllFilterButton = false;
            }
        }
        var elmnt = document.getElementById('CollectionProductsContainer');
        if (html) {
            elmnt.innerHTML = html.innerHTML;
        } else {
            let productResultContainer = elmnt.querySelector('[data-collection-products]');
            if (productResultContainer) {
                productResultContainer.innerHTML = noResultFound;
            }
        }
        updateGridView(elmnt);

        filters = document.getElementById('filterSideBar');
        filterContainer = elmnt;
        let inputId = input.getAttribute('id');
        let updateInput = document.getElementById(inputId);
        if (updateInput) {
            updateInput.focus();
            let moreOption = updateInput.closest('.more-options');
            if (moreOption) {
                moreOption.style.display = 'block';
                let moreOptionText = updateInput.closest('.yv-filter-content').querySelector('.filters-expand');
                if (moreOptionText) {
                    moreOptionText.classList.add('active');
                    moreOptionText.querySelector('span').innerHTML = showLessText;

                }
            }
        }
        if (itemResultCount) {
            document.querySelector('.products-count').innerHTML = itemResultCount.innerHTML;
        }
        if (document.getElementById('toolbox-sort')) {
            document.getElementById('toolbox-sort').innerHTML = sortByHtml;
        }
        sortBy();
        applyFilters();
        showMoreFilters();
        // hideShowFiltersEvent = false;
        hideFilters();
        if(animationStatus){
          if (AOS) { 
            AOS.refreshHard() 
          }
        }
        productHoverSlider();
        if (input.getAttribute('name') != 'sort_by' && elmnt.closest('.yv-collection-container')) {
            elmnt.closest('.yv-collection-container').scrollIntoView({ top: 150, behavior: "smooth" });
        }
        history.pushState({}, null, _updateUrl);
    });
}



let triggered = false;
let scrollCheckInterval = null;

// Pure JavaScript version of infinite scroll (fallback if jQuery version fails)
function initPureJSInfiniteScroll() {
    // Clear any existing interval
    if (scrollCheckInterval) {
        clearInterval(scrollCheckInterval);
    }
    
    // Check every 500ms if we should load more
    scrollCheckInterval = setInterval(function() {
        var moreButton = document.getElementById('more');
        
        if (!moreButton) {
            return;
        }
        
        if (triggered) {
            return;
        }
        
        // Check if button is visible in viewport
        var rect = moreButton.getBoundingClientRect();
        var isVisible = (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
        
        if (isVisible) {
            var link = moreButton.querySelector('a');
            if (link && link.getAttribute('href')) {
                loadMoreProducts(link.getAttribute('href'), moreButton);
            }
        }
    }, 500);
}

// Pure JS AJAX loader
function loadMoreProducts(url, moreButton) {
    triggered = true;
    
    // Show loader
    var loader = moreButton.querySelector('.load');
    if (loader) {
        loader.classList.remove('hidden');
    }
    
    fetch(url)
        .then(function(response) {
            return response.text();
        })
        .then(function(html) {
            // Parse the HTML
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newContainer = doc.querySelector('#CollectionProductsContainer');
            
            if (!newContainer) {
                triggered = false;
                return;
            }
            
            var newProducts = newContainer.querySelector('[data-collection-products]');
            
            if (!newProducts) {
                triggered = false;
                return;
            }
            
            // Get existing product container
            var existingContainer = document.querySelector('[data-collection-products]');
            
            if (!existingContainer) {
                triggered = false;
                return;
            }
            
            // Append new products
            var newProductItems = newProducts.querySelectorAll('[data-product-grid]');
            
            newProductItems.forEach(function(item) {
                existingContainer.appendChild(item.cloneNode(true));
            });
            
            // Remove the old more button
            if (moreButton && moreButton.parentNode) {
                moreButton.parentNode.removeChild(moreButton);
            }
            
            // Look for new more button in the response
            var newMoreButton = doc.getElementById('more');
            if (newMoreButton) {
                existingContainer.appendChild(newMoreButton.cloneNode(true));
            }
            
            // Update grid view
            if (typeof updateGridView === 'function') {
                updateGridView(document.getElementById('CollectionProductsContainer'));
            }
            
            // Reinitialize lazy loading for new images
            if (typeof lazySizes !== 'undefined') {
                lazySizes.autoSizer.checkElems();
            }
            
            // Call other functions if available
            if (typeof productVariants === 'function') {
                productVariants();
            }
            if (typeof gridPickUpAvailability === 'function') {
                gridPickUpAvailability();
            }
            if (typeof productHoverSlider === 'function') {
                productHoverSlider();
            }
            if (typeof AOS !== 'undefined' && animationStatus) {
                AOS.refreshHard();
            }
            
            triggered = false;
        })
        .catch(function(error) {
            triggered = false;
            if (loader) {
                loader.classList.add('hidden');
            }
        });
}

function ScrollExecute() {
    // Check if jQuery and required functions are available
    if (typeof jQuery === 'undefined') {
        return;
    }
    
    if (typeof screenVisibility !== 'function') {
        return;
    }
    
    var moreButon = $('#more').last();
    
    // If no more button exists, we're done
    if (!moreButon.length) {
        return;
    }
    
    var nextUrl = moreButon.find('a').attr("href");
    
    // If no next URL, we're done
    if (!nextUrl) {
        return;
    }
    
    if (screenVisibility(moreButon) && (triggered == false)) {
        triggered = true;
        $.ajax({
                url: nextUrl,
                type: 'GET',
                beforeSend: function() {
                    moreButon.find('.load').removeClass('hidden');
                }
            })
            .done(function(data) {
                moreButon.remove();
                var e = document.createElement('div');
                e.innerHTML = $(data).find('#CollectionProductsContainer').html();
                var newProducts = e.querySelector('[data-collection-products]');
                if (newProducts && newProducts.innerHTML) {
                    $('[data-collection-products]').append(newProducts.innerHTML);
                    updateGridView(document.getElementById('CollectionProductsContainer'));
                    
                    // Call additional functions if they exist
                    if (typeof productVariants === 'function') {
                        productVariants();
                    }
                    if (typeof gridPickUpAvailability === 'function') {
                        gridPickUpAvailability();
                    }
                    if (typeof productHoverSlider === 'function') {
                        productHoverSlider();
                    }
                    
                    if(animationStatus){
                      if (typeof AOS !== 'undefined') { 
                        AOS.refreshHard();
                      }
                    }
                }
                triggered = false;
            })
            .fail(function(xhr, status, error) {
                // Reset triggered on failure so we can try again
                triggered = false;
            });
    }
}
// Global object to store carousel intervals for pause/resume functionality
window.carouselIntervals = window.carouselIntervals || {};

// Global functions for pause/resume
window.pauseCarousel = function(imageIndex) {
    if (window.carouselIntervals[imageIndex]) {
        clearInterval(window.carouselIntervals[imageIndex]);
        window.carouselIntervals[imageIndex] = null;
    }
};

window.resumeCarousel = function(imageIndex) {
    if (!window.carouselIntervals[imageIndex] && window.carouselData && window.carouselData[imageIndex]) {
        var data = window.carouselData[imageIndex];
        startIndividualCarousel(data.imageIndex, data.currentIndex, data.imageUrls, data.overlayTitles, data.overlaySubtitles, data.cardTitles, data.ctaTexts, data.ctaLinks, data.randomInterval);
    }
};

// Store carousel data for resume functionality
window.carouselData = window.carouselData || {};

// Individual carousel function for pause/resume functionality
function startIndividualCarousel(imageIndex, startIndex, imageUrls, overlayTitles, overlaySubtitles, cardTitles, ctaTexts, ctaLinks, randomInterval) {
    var currentIndex = startIndex;
    var img = document.querySelector('#unsplash-img-' + imageIndex);
    var titleElement = document.querySelector('#unsplash-title-' + imageIndex);
    var overlayTitleElement = document.querySelector('#overlay-title-' + imageIndex);
    var overlaySubtitleElement = document.querySelector('#overlay-subtitle-' + imageIndex);
    var overlayCtaElement = document.querySelector('#overlay-cta-' + imageIndex);
    
    // Store current data for potential resume
    window.carouselData[imageIndex] = {
        imageIndex: imageIndex,
        currentIndex: currentIndex,
        imageUrls: imageUrls,
        overlayTitles: overlayTitles,
        overlaySubtitles: overlaySubtitles,
        cardTitles: cardTitles,
        ctaTexts: ctaTexts,
        ctaLinks: ctaLinks,
        randomInterval: randomInterval
    };
    
    window.carouselIntervals[imageIndex] = setInterval(function() {
        currentIndex = (currentIndex + 1) % imageUrls.length;
        
        // Update image with clean URL
        if (img) {
            var cleanUrl = imageUrls[currentIndex];
            // Fix duplicate /files/ in URLs
            if (cleanUrl && cleanUrl.includes('/files/files/')) {
                cleanUrl = cleanUrl.replace('/files/files/', '/files/');
            }
            img.src = cleanUrl;
        }
        
        // Update all text content
        if (titleElement && cardTitles[currentIndex]) {
            titleElement.textContent = cardTitles[currentIndex];
        }
        if (overlayTitleElement && overlayTitles[currentIndex]) {
            overlayTitleElement.textContent = overlayTitles[currentIndex];
        }
        if (overlaySubtitleElement && overlaySubtitles[currentIndex]) {
            overlaySubtitleElement.textContent = overlaySubtitles[currentIndex];
        }
        if (overlayCtaElement && ctaTexts[currentIndex] && ctaLinks[currentIndex]) {
            overlayCtaElement.textContent = ctaTexts[currentIndex];
            overlayCtaElement.href = ctaLinks[currentIndex];
        }
        
        // Update stored current index
        window.carouselData[imageIndex].currentIndex = currentIndex;
    }, randomInterval);
}

// Image carousel functionality for Unsplash images
function startUnsplashCarousels() {
    // Only run rotating images for collage_it template
    var mainSection = document.getElementById('CollectionProductsContainer');
    var isCollageItTemplate = mainSection && mainSection.getAttribute('data-collage-it') === 'true';
    
    if (!isCollageItTemplate) {
        return; // Exit early if not collage_it template
    }
    
    // Find all Unsplash items
    var unsplashItems = document.querySelectorAll('.unsplash-item[data-image-index]');
    
    unsplashItems.forEach(function(item, index) {
        var imageIndex = item.getAttribute('data-image-index');
        var img = item.querySelector('#unsplash-img-' + imageIndex);
        var titleElement = document.querySelector('#unsplash-title-' + imageIndex);
        var overlayTitleElement = document.querySelector('#overlay-title-' + imageIndex);
        var overlaySubtitleElement = document.querySelector('#overlay-subtitle-' + imageIndex);
        var overlayCtaElement = document.querySelector('#overlay-cta-' + imageIndex);
        var dataScript = item.querySelector('#image-data-' + imageIndex);
        var overlayTitlesScript = document.querySelector('#overlay-titles-' + imageIndex);
        var overlaySubtitlesScript = document.querySelector('#overlay-subtitles-' + imageIndex);
        var cardTitlesScript = document.querySelector('#card-titles-' + imageIndex);
        var ctaTextsScript = document.querySelector('#cta-texts-' + imageIndex);
        var ctaLinksScript = document.querySelector('#cta-links-' + imageIndex);
        
        if (!img || !dataScript) return;
        
        try {
            var imageUrls = JSON.parse(dataScript.textContent);
            var overlayTitles = overlayTitlesScript ? JSON.parse(overlayTitlesScript.textContent) : [];
            var overlaySubtitles = overlaySubtitlesScript ? JSON.parse(overlaySubtitlesScript.textContent) : [];
            var cardTitles = cardTitlesScript ? JSON.parse(cardTitlesScript.textContent) : [];
            var ctaTexts = ctaTextsScript ? JSON.parse(ctaTextsScript.textContent) : [];
            var ctaLinks = ctaLinksScript ? JSON.parse(ctaLinksScript.textContent) : [];
            
            if (imageUrls.length <= 1) return;
            
            // Start each carousel at a different image index
            var currentIndex = index % imageUrls.length;
            
            // Set initial image and all text based on starting index
            var cleanInitialUrl = imageUrls[currentIndex];
            // Fix duplicate /files/ in URLs
            if (cleanInitialUrl && cleanInitialUrl.includes('/files/files/')) {
                cleanInitialUrl = cleanInitialUrl.replace('/files/files/', '/files/');
            }
            img.src = cleanInitialUrl;
            if (titleElement && cardTitles[currentIndex]) {
                titleElement.textContent = cardTitles[currentIndex];
            }
            if (overlayTitleElement && overlayTitles[currentIndex]) {
                overlayTitleElement.textContent = overlayTitles[currentIndex];
            }
            if (overlaySubtitleElement && overlaySubtitles[currentIndex]) {
                overlaySubtitleElement.textContent = overlaySubtitles[currentIndex];
            }
            if (overlayCtaElement && ctaTexts[currentIndex] && ctaLinks[currentIndex]) {
                overlayCtaElement.textContent = ctaTexts[currentIndex];
                overlayCtaElement.href = ctaLinks[currentIndex];
            }
            
            // Generate random interval between 30-60 seconds for each carousel (45 ± 15 seconds)
            var randomInterval = Math.random() * 30000 + 30000; // 30000-60000ms (30-60 seconds)
            
            // Add random delay before starting each carousel (0-1 second)
            var randomDelay = Math.random() * 1000;
            
            // Start image rotation with randomized timing and delay
            setTimeout(function() {
                startIndividualCarousel(imageIndex, currentIndex, imageUrls, overlayTitles, overlaySubtitles, cardTitles, ctaTexts, ctaLinks, randomInterval);
            }, randomDelay);
            
        } catch (e) {
            console.error('Error parsing image data:', e);
        }
    });
}

// Initialize carousels on page load
document.addEventListener('DOMContentLoaded', function() {
    startUnsplashCarousels();
});

// Carousels are now started in the main updateGridView function above

// Initialize scroll listener when DOM and jQuery are ready
function initInfiniteScroll() {
    if (typeof jQuery === 'undefined') {
        // Start pure JS version immediately
        initPureJSInfiniteScroll();
        
        // Still try to initialize jQuery version later
        setTimeout(initInfiniteScroll, 100);
        return;
    }
    
    var scrollHandler = function() {
        ScrollExecute();
    };
    
    $(window).on('scroll', scrollHandler);
    
    // Also start the pure JS version as a backup
    initPureJSInfiniteScroll();
    
    // Also trigger once on load in case user is already scrolled down
    setTimeout(function() {
        ScrollExecute();
    }, 1000);
    
    // Add another check after 3 seconds
    setTimeout(function() {
        ScrollExecute();
    }, 3000);
}

// Try multiple initialization methods to ensure it works
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInfiniteScroll);
} else {
    initInfiniteScroll();
}

// Fallback: also use jQuery ready if available
if (typeof jQuery !== 'undefined') {
    $(document).ready(function() {
        initInfiniteScroll();
    });
}